module.exports = __webpack_public_path__ + "img/lawyer-pain-point-1.ebb808da.png";